import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/export-duck";
import { TransportWithPicking } from "interfaces/transport";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "EXPORT_SCHEDULING_ORDER_FOB_" }
);

export interface ExportSchedulingOrderFOBState extends IState {
  data: TransportWithPicking[];
}

interface ISuccessExportSchedulingOrderFOBAction extends ISuccessAction {
  data: TransportWithPicking[];
}

const INITIAL_STATE: ExportSchedulingOrderFOBState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ExportSchedulingOrderFOBState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: ExportSchedulingOrderFOBState,
  action: ISuccessExportSchedulingOrderFOBAction
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ExportSchedulingOrderFOBState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const exportSchedulingOrderFOB = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ExportSchedulingOrderFOBTypes = Types;
export const ExportSchedulingOrderFOBActions = Creators;